import { useForm, Controller } from "react-hook-form";
import { FormContainer, ToggleSwitchBtn, TextInput } from "../../shared";
import { RESET_PASSWORD } from "./query";
import useGlobalMutation from "../../../hooks/useGlobalMutation";
import { RegexPattern } from "../../../utils";

const ResetPassword = ({ id }) => {
    const {
        register,
        control,
        handleSubmit,
        formState: { errors },
        reset,
        watch,
    } = useForm({
        mode: "onChange",
    });

    const password = watch("password", "");
    const sendToEmail = watch("sendToEmail", false);

    const ischecked = (value) => (value ? 1 : 0);

    const { submitMutation, loading } = useGlobalMutation(RESET_PASSWORD);

    const submitAction = handleSubmit(async (data) => {
        const { password, sendToEmail } = data;
        const variables = {
            id,
            password: password || "",
            isEmail: ischecked(sendToEmail),
        };
        const successMgs = sendToEmail
            ? `Password reset link sent to mail`
            : `Password successfully reset`;

        const isResultNull = await submitMutation(variables, "basicLoginResetPassword", successMgs);

        isResultNull === null && reset();
    });

    return (
        <FormContainer submitAction={submitAction} loading={loading} submitBtnSm>
            <h5 className="mb-4">Reset Password</h5>

            <div className="row">
                <div className="col-12">
                    <label className="h6 mb-3">
                        Send Set Password Link To this User Email Address
                    </label>
                    <Controller
                        name="sendToEmail"
                        control={control}
                        render={({ field: { onChange, ref } }) => (
                            <ToggleSwitchBtn
                                id="sendToEmail"
                                name="sendToEmail"
                                onChange={onChange}
                                ref={ref}
                            />
                        )}
                    />
                </div>

                <div className="col-md-6">
                    <Controller
                        name="password"
                        control={control}
                        render={({ field: { ref } }) => (
                            <TextInput
                                id="password"
                                labelText="Password"
                                type="password"
                                isInvalid={!!errors.password && !sendToEmail}
                                required={!sendToEmail}
                                errorMessage={
                                    (!sendToEmail && errors.password && errors.password.message) ||
                                    "Invalid Password"
                                }
                                disabled={sendToEmail}
                                ref={ref}
                                {...register("password", {
                                    required: !sendToEmail,
                                    pattern: RegexPattern.password,
                                })}
                            />
                        )}
                    />
                </div>
                <div className="col-md-6">
                    <Controller
                        name="confirmPassword"
                        control={control}
                        render={({ field: { ref } }) => (
                            <TextInput
                                id="confirmPassword"
                                labelText="Confirm Password"
                                type="password"
                                isInvalid={!!errors.confirmPassword && !sendToEmail}
                                required={!sendToEmail}
                                errorMessage={
                                    (!sendToEmail &&
                                        errors.confirmPassword &&
                                        errors.confirmPassword.message) ||
                                    "Invalid Password"
                                }
                                ref={ref}
                                disabled={sendToEmail}
                                {...register("confirmPassword", {
                                    required: !sendToEmail,
                                    validate: (value) =>
                                        value === password ||
                                        sendToEmail ||
                                        "Passwords do not match",
                                })}
                            />
                        )}
                    />
                </div>
            </div>
        </FormContainer>
    );
};

export default ResetPassword;
